import { createContext, useContext, useEffect } from 'react';

/**
 * A panel that needs another width than its type gives (a form beside the
 * week it falls in, a screen of a wide panel that reads as a narrow one) asks
 * the slide-over for it while it is shown: useSlideOverWidth(width) inside it.
 * The portal provides the setter and gives the type's width back on unmount.
 */
export const SlideOverWidthContext = createContext(() => {});

export const WIDE_SLIDE_OVER_WIDTH = 'lg:w-[min(1280px,calc(100vw_-_4rem))]';
// The width of the task panels and forms.
export const NARROW_SLIDE_OVER_WIDTH = 'lg:w-[600px]';

export const useSlideOverWidth = (width, active = true) => {
  const setWidth = useContext(SlideOverWidthContext);
  useEffect(() => {
    if (!active) return undefined;
    setWidth(width);
    return () => setWidth(null);
  }, [setWidth, width, active]);
};

const useWideSlideOver = (wide = true) => useSlideOverWidth(WIDE_SLIDE_OVER_WIDTH, wide);

export default useWideSlideOver;
